/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */

import { ALL_CONDITION } from "./filter/FilterTag";
import { Category } from "../logic/hook/useCategories";

const ConditionList = (mainCategories: Category[] | undefined) => {
    if (!mainCategories) return;
    const maxNum = mainCategories.length;
    const dotColors = ["#EA5850", "#CC0022"];

    const _conditionList = mainCategories.map((item, index) => {
        const color = maxNum === 2 ? dotColors[index] : dotColors[1];

        return {
            name: item.name,
            id: item.id,
            dotColor: color,
        };
    });

    _conditionList.reverse();

    const conditionList = [{ name: ALL_CONDITION.name, id: ALL_CONDITION.id }, ..._conditionList];
    return conditionList;
};

export default ConditionList;
